
//URL to get all the img logged on segurnet server
export const URL_IMG_BASE:string = 'https://servicios.segurnet.com.do/public/images';

// Table header poliza
export const TABLE_POL_HEADERS = ['Tipo de póliza', 'Num. póliza', 'Vigencia', 'Marbete', 'Contrato', 'Estado'];

//GeneriObj
export interface IObjGeneric {
 [key: string]: unknown;
}